import React, { useEffect, useState, useRef } from 'react';
import AsyncSelect from "react-select/async";
import { useNavigate } from "react-router-dom";
import { customFetch } from '../apiClient';
import Select from 'react-select';

const roomCategories = [
  { label: "PRICATE AC ROOM", value: "AC" },
  { label: "PRIVATE NON AC ROOM", value: "NON-AC" },
  { label: "General WARD", value: "GENERAL" },
  { label: "ICU WARD", value: "ICU" },     
  { label: "NICU WARD", value: "NICU" }, 
  { label: "EMERGENCY WARD", value: "EMERGENCY" },
   { label: "PRIVATE ICU ROOM", value: "PRIVATE-ICU-ROOM" }
];
const getLocalISOString = () => {
  const tzOffset = new Date().getTimezoneOffset() * 60000;
  return new Date(Date.now() - tzOffset).toISOString().slice(0, 16);
};

// Yahan isko object se function bana diya gaya hai
const getInitialForm = () => ({
  R_IPD_ID: null,
  RoomCatge: null,
  RoomID: null,
  RoomNo: "",
  RoomRate: "",
  EntryDate: getLocalISOString(),
  Remarks: ""
});


const IPDRoomBookingForm = ({ onSubmitSuccess }) => {
  const [form, setForm] = useState(getInitialForm);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [roomOptions, setRoomOptions] = useState([]);
  const [touched, setTouched] = useState({});
  const [selectedPatientLabel, setSelectedPatientLabel] = useState(null);

  const navigate = useNavigate();
  const formRef = useRef(null);
  const roomSelectRef = useRef(null); // ✅ नया Ref

  // Auto-focus first input
  useEffect(() => {
    if (formRef.current) {
      const firstInput = formRef.current.querySelector(
        'input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, button:not([disabled])'
      );
      firstInput?.focus();
    }
  }, []);



  useEffect(() => {
    const intervalId = setInterval(() => {
      setForm(prev => {
        // Agar user ne manually date edit NAHI ki hai, tabhi live time update hoga
        if (!touched.EntryDate) {
          return { ...prev, EntryDate: getLocalISOString() };
        }
        return prev;
      });
    }, 60000); // 60000 ms = 1 minute

    return () => clearInterval(intervalId);
  }, [touched.EntryDate]);

  // Auto-dismiss alerts
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

 const loadIpdOptions = async (inputValue) => {
    if (!inputValue) return [];
   try {
      const res = await customFetch(`/Ipds/list?search=${encodeURIComponent(inputValue)}`);
      
      if (!res.ok) throw new Error("Failed");
      const data = await res.json();
      
      return data.map((item) => {
        // ✅ Changed ipD_Date to regDate 
        const regDateFormatted = item.regDate 
            ? new Date(item.regDate).toLocaleDateString('en-IN', { 
                day: '2-digit', month: 'short', year: 'numeric' 
              }) 
            : "N/A";

        return {
          // ✅ Label updated to show Reg Date
          label: `${item.name} (${item.mobileNo}) | UHID: ${item.uhiD_No} | IPD No: ${item.ipD_SRNO} | Reg Date: ${regDateFormatted}`,
          value: item.ipD_ID,
          admDate: item.regDate, // Isko regDate se map kar diya taaki form mein save karte waqt yahi date jaye
          name: item.name,
        };
      });
    } catch { 
      return []; 
    }
  };
  // When IPD patient changes
  const handleIpdChange = (selectedOption) => {
    setForm(prev => ({
      ...prev,
      R_IPD_ID: selectedOption ? selectedOption.value : null,
      RoomCatge: null,
      RoomID: null,
      RoomNo: "",
      RoomRate: ""
    }));

    setSelectedPatientLabel(selectedOption);
    setRoomOptions([]);
    setError("");
    setSuccess("");
    setTouched(prev => ({ ...prev, R_IPD_ID: true }));
  };
const handleRoomCategoryChange = async (selectedOption) => {
    const selectedCat = selectedOption ? selectedOption.value : null;

    setForm(prev => ({
      ...prev,
      RoomCatge: selectedCat,
      RoomID: null,
      RoomNo: "",
      RoomRate: ""
    }));
    setTouched(prev => ({ ...prev, RoomCatge: true }));

    if (!selectedCat) {
      setRoomOptions([]);
      return;
    }

    setLoading(true);
    setError("");
   try {
      const hid = sessionStorage.getItem("hospitalId");
      const res = await customFetch(`/Room/by-category?category=${encodeURIComponent(selectedCat)}&status=Active&hid=${hid}`);
      if (!res.ok) throw new Error("Failed to load rooms");
      const rooms = await res.json();
      setRoomOptions(rooms.map(room => ({
        label: `Room No: ${room.roomNo} (Charge: ₹${Number(room.room_Charge || 0).toFixed(2)})`,
        value: room.room_ID,
        roomNo: room.roomNo,
        roomRate: room.room_Charge || 0
      })));
    } catch (err) {
      setError(err.message);
      setRoomOptions([]);
    } finally {
      setLoading(false);
      // ✅ बस यह हिस्सा नया जुड़ा है: API कॉल के बाद 'Select Room' पर फोकस भेजना
      setTimeout(() => {
        if (roomSelectRef.current) {
          roomSelectRef.current.focus();
        }
      }, 50);
    }
  };

  const handleRoomSelectChange = (selectedOption) => {
    if (!selectedOption) {
      setForm(prev => ({
        ...prev,
        RoomID: null,
        RoomNo: "",
        RoomRate: ""
      }));
      return;
    }
    setForm(prev => ({
      ...prev,
      RoomID: selectedOption.value,
      RoomNo: selectedOption.roomNo,
      RoomRate: selectedOption.roomRate
    }));
    setTouched(prev => ({ ...prev, RoomID: true }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setTouched(prev => ({ ...prev, [name]: true }));
  };

  // ==================== NEW KEYBOARD NAVIGATION ====================
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Keval Enter key ko intercept karo, ArrowDown native react-select handle karega
      if (e.key !== 'Enter') return;

      // Agar react-select dropdown open hai aur user option select kar raha hai, toh skip karo
      if (e.target.closest('.react-select__menu')) return;
      
      if (e.target.closest('.react-select__input-container')) {
        // Agar react-select focused hai aur menu open hai, tab select hone do
        if (e.target.getAttribute('aria-expanded') === 'true') {
          return;
        }
      }

      const focusableSelector = 
        'input:not([disabled]):not([type="hidden"]):not([readonly]), ' +
        'select:not([disabled]), ' +
        'textarea:not([disabled]):not([readonly]), ' +
        'button:not([disabled])';

      const focusableElements = Array.from(
        formRef.current?.querySelectorAll(focusableSelector) || []
      );

      if (focusableElements.length === 0) return;
      const currentIndex = focusableElements.indexOf(document.activeElement);

      // Agar last element (Submit Button) par Enter dabaya toh submit
      if (currentIndex === focusableElements.length - 1) {
        e.preventDefault();
        formRef.current?.requestSubmit();
        return;
      }

      // Baaki elements (incuding Textarea) se aage badho aur nayi line aane se roko
      if (currentIndex >= 0) {
        e.preventDefault(); // Ye Textarea me New Line add nahi hone dega!
        focusableElements[currentIndex + 1]?.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
  // ================================================================

  // Form submit: Room booking save
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!form.R_IPD_ID || !form.RoomCatge || !form.RoomID) {
      setError("Please select patient, room category, and room.");
      return;
    }
    if (!form.EntryDate) {
      setError("Please enter entry date.");
      return;
    }

    setLoading(true);
    try {
      
      const hid = sessionStorage.getItem("hospitalId");

      const payload = {
        R_IPD_ID: form.R_IPD_ID,
        RoomCatge: form.RoomCatge,
        RoomID: form.RoomID,
        RoomNo: form.RoomNo,
        RoomRate: form.RoomRate,
        EntryDate: form.EntryDate,
        Remarks: form.Remarks,
        HID: hid ? Number(hid) : null,
        SyncSts: false
      };

     const res = await customFetch(`/IPDRoom`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || "Failed to book room");
      }

      setSuccess("Room booked successfully!");
      setForm(getInitialForm());
      setRoomOptions([]);
      setTouched({});
      setSelectedPatientLabel(null);

      if (onSubmitSuccess) onSubmitSuccess();

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

 const handleButtonClick = () => {
    navigate('/clinical/room-update'); // ✅ Clinical Layout me bhejega
  };

  const handleReset = () => {
    setSelectedPatientLabel(null);
  setForm(getInitialForm());
    setRoomOptions([]);
    setTouched({});
    setError("");
    setSuccess("");
  };

  // ✅ SCALED DOWN COMPACT REACT SELECT STYLES
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '30px', /* Compact Height */
      fontSize: '11px',  /* Compact Font */
      borderRadius: '6px',
      borderColor: state.isFocused ? 'var(--theme-color, #0088cc)' : '#cbd5e0',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(0, 0, 0, 0.05)' : 'none',
      '&:hover': { borderColor: 'var(--theme-color, #0088cc)' },
      borderWidth: '1.5px'
    }),
    valueContainer: (base) => ({ ...base, padding: '0 6px' }),
    input: (base) => ({ ...base, margin: '0', padding: '0' }),
    dropdownIndicator: (base) => ({ ...base, padding: '4px' }),
    clearIndicator: (base) => ({ ...base, padding: '4px' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ 
      ...base, 
      zIndex: 9999,
      borderRadius: '6px',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e0e6ed',
      fontSize: '11px'
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '11px',
      padding: '6px 10px',
      backgroundColor: state.isFocused 
        ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)' 
        : 'white',
      color: '#333',
      cursor: 'pointer',
      '&:active': { backgroundColor: 'var(--theme-color, #0088cc)', color: 'white' }
    }),
    placeholder: (base) => ({ ...base, color: '#a0aec0', fontSize: '11px' })
  };

  return (
    <div className="room-booking-container compact-ui">
      <div className="room-booking-card">
        {/* Header */}
        <div className="room-booking-header">
          <div className="header-left">
            <div className="header-icon">
              <i className="bi bi-door-open"></i>
            </div>
            <div className="header-text">
              <h5>Room Booking</h5>
              <p>Assign and manage room bookings for IPD patients</p>
            </div>
          </div>
          <button type="button" className="btn-view-list" onClick={handleButtonClick} title="Update Room Bookings">
            <i className="bi bi-pencil-square"></i>
            Update Bookings
          </button>
        </div>

        {/* Alerts */}
        {error && (
          <div className="alert-custom alert-danger slide-in">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <span>{error}</span>
            <button type="button" className="alert-close" onClick={() => setError("")}>
              <i className="bi bi-x"></i>
            </button>
          </div>
        )}
        {success && (
          <div className="alert-custom alert-success slide-in">
            <i className="bi bi-check-circle-fill"></i>
            <span>{success}</span>
            <button type="button" className="alert-close" onClick={() => setSuccess("")}>
              <i className="bi bi-x"></i>
            </button>
          </div>
        )}

        {/* Form */}
        <form ref={formRef} onSubmit={handleSubmit} className="room-booking-form">
          <div className="form-section">
            <div className="section-title">
              <i className="bi bi-plus-circle"></i>
              <span>New Room Booking</span>
            </div>

            <div className="section-content">
              {/* Patient Selection */}
              <div className="form-group">
                <label>
                  <i className="bi bi-person-search"></i>
                  Search Patient (IPD) <span className="required">*</span>
                </label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={loadIpdOptions}
                  tabIndex={1}
                  onChange={handleIpdChange}
                  placeholder="Start typing patient name/mobile/SrNo..."
                  value={selectedPatientLabel}
                  isClearable
                  isDisabled={loading}
                  styles={selectStyles}
                  menuPortalTarget={document.body}
                />
              </div>

              {/* Room Details Row */}
              <div className="form-row three-col">
                <div className="form-group">
                  <label>
                    <i className="bi bi-tag"></i>
                    Room Category <span className="required">*</span>
                  </label>
                 <Select
                    options={roomCategories}
                    value={roomCategories.find(c => c.value === form.RoomCatge)}
                    onChange={handleRoomCategoryChange}
                    placeholder="-- Select Category --"
                    isClearable
                    isDisabled={!form.R_IPD_ID || loading}
                    styles={selectStyles}
                    tabIndex={2}
                    menuPortalTarget={document.body}
                  />
                </div>

              <div className="form-group flex-2">
                  <label>
                    <i className="bi bi-door-closed"></i>
                    Select Room <span className="required">*</span>
                  </label>
                <Select
                  ref={roomSelectRef} // ✅ Ref यहाँ लगाया गया है
                  options={roomOptions}
                  value={roomOptions.find(r => r.value === form.RoomID)}
                  onChange={handleRoomSelectChange}
                  placeholder="-- Select Room --"
                  isClearable
                  isDisabled={!form.RoomCatge} // ✅ यहाँ से 'loading' हटा दिया गया है
                  isLoading={loading} // ✅ लोडिंग के दौरान स्पिनर दिखाने के लिए
                  styles={selectStyles}
                  tabIndex={3}
                  noOptionsMessage={() => form.RoomCatge ? "No rooms available" : "Select Category first"}
                  menuPortalTarget={document.body}
                />
                </div>
              </div>

              {/* Entry Date & Room Info */}
              <div className="form-row three-col">
                <div className="form-group">
                  <label>
                    <i className="bi bi-calendar-date"></i>
                    Entry Date <span className="required">*</span>
                  </label>
                  <input
                    type="datetime-local"
                    tabIndex={4}
                    name="EntryDate"
                    className="form-control-custom"
                    value={form.EntryDate}
                    onChange={handleChange}
                    disabled={loading}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    <i className="bi bi-123"></i>
                    Room No
                  </label>
                  <input 
                    type="text" 
                    tabIndex={5} 
                    className="form-control-custom" 
                    value={form.RoomNo} 
                    readOnly 
                    placeholder="Auto-filled"
                  />
                </div>

                <div className="form-group">
                  <label>
                    <i className="bi bi-currency-rupee"></i>
                    Room Rate (₹)
                  </label>
                  <input 
                    type="text" 
                    tabIndex={6} 
                    className="form-control-custom" 
                    value={form.RoomRate} 
                    readOnly 
                    placeholder="Auto-filled"
                  />
                </div>
              </div>

              {/* Remarks */}
              <div className="form-group">
                <label>
                  <i className="bi bi-chat-left-text"></i>
                  Remarks
                </label>
                <textarea
                  name="Remarks"
                  value={form.Remarks}
                  tabIndex={7}
                  onChange={handleChange}
                  className="form-control-custom custom-textarea"
                  placeholder="Additional comments or instructions..."
                  rows={2}
                  maxLength={200}
                  disabled={loading}
                />
              </div>
            </div>
          </div>

          {/* Form Actions */}
          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={handleReset} disabled={loading}>
              <i className="bi bi-arrow-clockwise"></i>
              Reset
            </button>
            <button
              type="submit"
              className="btn-primary"
              tabIndex={8}
              disabled={loading || !form.R_IPD_ID || !form.RoomCatge || !form.RoomID || !form.EntryDate}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Booking...
                </>
              ) : (
                <>
                  <i className="bi bi-check-circle"></i>
                  Book Room
                </>
              )}
            </button>
          </div>
        </form>
      </div>

      <style jsx>{`
        .compact-ui {
          font-family: system-ui, -apple-system, sans-serif;
        }

        .room-booking-container {
          padding: 0;
        }

        .room-booking-card {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
          border: 1px solid #e0e6ed;
          overflow: visible; /* crucial for react select rendering */
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .slide-in { animation: slideIn 0.2s ease; }

        /* Header */
        .room-booking-header {
          background: var(--theme-color, #0088cc); 
          padding: 10px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 2px solid rgba(0,0,0,0.1);
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }

        .header-left { display: flex; align-items: center; gap: 10px; }

        .header-icon {
          width: 32px; height: 32px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 6px;
          display: flex; align-items: center; justify-content: center;
          font-size: 16px; color: white;
        }

        .header-text h5 { margin: 0; color: white; font-size: 15px; font-weight: 600; line-height: 1.1; }
        .header-text p { margin: 0; color: rgba(255, 255, 255, 0.85); font-size: 10px; }

        .btn-view-list {
          padding: 6px 12px; border-radius: 6px;
          border: 1.5px solid rgba(255, 255, 255, 0.3);
          background: rgba(255, 255, 255, 0.15);
          color: white; font-size: 11px; font-weight: 600; cursor: pointer;
          transition: all 0.2s ease; display: flex; align-items: center; gap: 5px;
        }
        .btn-view-list:hover {
          background: white;
          color: var(--theme-color, #0088cc);
          transform: translateY(-1px);
        }

        /* Alerts */
        .alert-custom {
          margin: 10px 16px 0; padding: 8px 12px; border-radius: 6px;
          display: flex; align-items: center; gap: 8px;
          font-size: 11px; font-weight: 500; position: relative;
        }
        .alert-danger { background: #fee; color: #c33; border: 1px solid #fcc; }
        .alert-success { background: #d4edda; color: #155724; border: 1px solid #c3e6cb; }
        .alert-custom i { font-size: 13px; }
        .alert-close { position: absolute; right: 8px; background: transparent; border: none; cursor: pointer; opacity: 0.6; padding: 0;}
        .alert-close:hover { opacity: 1; }

        /* Form */
        .room-booking-form { padding: 12px 16px; }

        .form-section {
          background: #f8f9fa;
          border: 1px solid #e0e6ed; border-radius: 8px;
          margin-bottom: 12px; overflow: visible;
        }

        .section-title {
          background: var(--theme-color, #0088cc);
          padding: 8px 12px; display: flex; align-items: center; gap: 6px;
          border-top-left-radius: 8px; border-top-right-radius: 8px;
        }

        .section-title i { font-size: 13px; color: white; }
        .section-title span { font-size: 12px; font-weight: 600; color: white; flex: 1; }

        .section-content { padding: 12px; background: white; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;}

        .form-row { display: grid; gap: 10px; margin-bottom: 10px; }
        .form-row:last-child { margin-bottom: 0; }
        .form-row.three-col { grid-template-columns: repeat(3, 1fr); }

        .form-group { display: flex; flex-direction: column; margin-bottom: 8px; }
        .form-group.flex-2 { grid-column: span 2; }

        .form-group label {
          font-size: 11px; font-weight: 600; color: #2c3e50;
          margin-bottom: 4px; display: flex; align-items: center; gap: 4px;
        }

        .form-group label i { color: var(--theme-color, #0088cc); font-size: 10px; }
        .required { color: #e74c3c; }

        /* Inputs & Selects */
        .form-control-custom {
          width: 100%; padding: 6px 10px; height: 30px;
          border: 1.5px solid #cbd5e0; border-radius: 6px;
          font-size: 11px; color: #2c3e50; transition: all 0.2s ease;
          outline: none; background: white;
        }

        .form-control-custom:focus {
          border-color: var(--theme-color, #0088cc);
          box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
        }

        .form-control-custom::placeholder { color: #a0aec0; font-size: 11px; }
        
        .form-control-custom:disabled {
          background: #f3f4f6; opacity: 0.6; cursor: not-allowed;
        }

        .form-control-custom:read-only { background: #f8f9fa; color: #6c757d; }

        .custom-textarea { resize: vertical; min-height: 50px; height: auto; font-family: inherit; }

        .form-actions {
          display: flex; justify-content: flex-end; gap: 8px;
          margin-top: 12px; padding-top: 12px; border-top: 1px solid #e0e6ed;
        }

        .btn-primary, .btn-secondary {
          padding: 6px 16px; border-radius: 6px;
          font-size: 11px; font-weight: 600; border: none; cursor: pointer;
          transition: all 0.2s ease; display: flex; align-items: center; gap: 5px;
        }

        .btn-primary { background: var(--theme-color, #0088cc); color: white; }
        .btn-primary:hover:not(:disabled) { transform: translateY(-1px); opacity: 0.9; }
        .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

        .btn-secondary { background: #e0e6ed; color: #2c3e50; }
        .btn-secondary:hover:not(:disabled) { background: #cbd5e0; transform: translateY(-1px); }
        .btn-secondary:disabled { opacity: 0.6; cursor: not-allowed; }

        @media (max-width: 768px) {
          .room-booking-header { flex-direction: column; gap: 8px; }
          .form-row.three-col { grid-template-columns: 1fr; }
          .form-group.flex-2 { grid-column: span 1; }
          .form-actions { flex-direction: column; }
          .btn-primary, .btn-secondary { width: 100%; justify-content: center; }
        }
      `}</style>
    </div>
  );
};

export default IPDRoomBookingForm;